import { render, staticRenderFns } from "./VpnReservedList.vue?vue&type=template&id=3e3296be&"
import script from "./VpnReservedList.vue?vue&type=script&lang=ts&"
export * from "./VpnReservedList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports